<template>
  <div class="bg-f5">
    <ConsultTip text='医生咨询仅提供咨询服务，不能在线问诊开处方' />
    <div class="container-wrap-form doc-consult">
      <PatientBar />
      <SearchInput
        inputColor='white'
        placeholder='搜索医院、科室、医生、疾病'
        @on-input='focus'
        @on-clear='clear'
      />
      <div class="consult-menu" v-if="menuShow && version != 'fever'">
        <div class="title" @click="filter('dept', '1')">
          <span>常用科室</span>
        </div>
        <ul class="clearfix">
          <li v-for="(item,i) in deptRecos" :key="i" @click="searchDept(item)">
            <div class="menu-icon">
              <img
                v-if="item.iconUrl"
                :src="item.iconUrl"
                icon-default-dept
                :onerror="getDefaultDeptUrl('1')"
              />
              <img v-else src="../../assets/images/consult-menu/icon-default-dept.png" >
            </div>
            <p>{{item.deptName}}</p>
          </li>
        </ul>
      </div>
      <div class="consult-hosp-depart">
        <div class="msg-list"
          v-infinite-scroll="loadMore"
          infinite-scroll-immediate-check="false"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="10">
          <div class="msg-item" v-for="(doc,i) in doctors" :key="i">
            <div class="msg-up" @click="check(doc)">
              <div class="img-left">
                <img
                  :src="doc.imgUrl?doc.imgUrl:defaultMaleAvatarUrl"
                  alt
                  :class="{'grayscale':doc.onlineStatus!='1'}"
                  v-if="doc.gender==='1'"
                  :onerror="getDefaultAvatarUrl('1')"
                />
                <img :class="{'grayscale':doc.onlineStatus!='1'}" :src="doc.imgUrl?doc.imgUrl:defaultFemaleAvatarUrl" alt v-else :onerror="getDefaultAvatarUrl('2')"/>
                <span
                  class="is-online"
                  :class="{leave:doc.onlineStatus!='1'}"
                >{{doc.onlineStatus==='1'?'在线':'离线'}}</span>
              </div>
              <div class="img-content">
                <div class="clearfix msg-info">
                  <p class="fn-fl msg-con">
                    <span>{{doc.name}}</span>
                    <i>{{doc.postName}}</i>
                  </p>
                </div>
                <p class="msg-tip">{{doc.phospName}} | {{doc.deptName}}</p>
                <p class="msg-tip">
                  <span>咨询量 {{doc.consultCnt}}</span>
                </p>
                <p class="msg-tip good">擅长：{{ doc.doctorSkill && doc.doctorSkill.replace(/^擅长/, "") || '暂无擅长描述' }}</p>
              </div>
            </div>
            <div class="form-table msg-opt">
              <span class="table-left" v-if="doc.statusImage === '1'" @click="handleConsult(doc, 'img')">
                <i class="opt-img"></i>
                <template v-if="isMini">
                  {{ doc.costsImage? `${financial(doc.costsImage)}元` : '-' }}
                </template>
                <template v-else>
                  图文免费咨询
                </template>
              </span>
              <span class="table-left inactive" v-else @click="handleConsult(doc, 'img')">
                <i class="opt-img"></i>暂未开通
              </span>
              <span class="table-left" v-if="doc.statusVideo === '1' && isMini" @click="handleConsult(doc, 'video')">
                <i class="opt-video"></i>
                {{ doc.costsVideo? `${financial(doc.costsVideo)}元` : '-' }}
              </span>
              <span class="table-left inactive" v-else @click="handleConsult(doc, 'video')">
                <i class="opt-video"></i>视频暂未开通
              </span>
            </div>
          </div>
          <div class="msg-item empty" v-if="doctors && doctors.length === 0 && !loading">
            <div class="empty-tip">暂无匹配结果</div>
          </div>
        </div>
      </div>
    </div>
    <schedulPicker
      ref="schedulPicker"
      :doctorInfo="doctorInfo"
      :dataList="pickerDataList"
      @closePicker="closePicker"
      @createForm="enterConsultion"
      v-if="pickerFlag">
    </schedulPicker>
    <SuspensionTips :version='version' />
  </div>
</template>

<script>
import * as $services from '@/services/index'
import schedulPicker from '../common/schedulPicker'
import SearchInput from '@/components/common/SearchInput'
import SuspensionTips from '@/components/common/SuspensionTips'
import PatientBar from '@/components/common/PatientBar'
import ConsultTip from '@/components/common/ConsultTip'
import api from '@/config/api'
import { mapGetters } from 'vuex'

export default {
  components: {
    SearchInput: SearchInput,
    schedulPicker: schedulPicker,
    SuspensionTips: SuspensionTips,
    PatientBar: PatientBar,
    ConsultTip: ConsultTip
  },
  filters: {
    formatNull (value) {
      return value || '-'
    }
  },
  data () {
    return {
      isMini: false,
      defaultFemaleAvatarUrl: require('../../assets/images/jidayi-hospital/icon-doctor-female.png'),
      defaultMaleAvatarUrl: require('../../assets/images/jidayi-hospital/icon-doctor-male.png'),
      defaultDeptUrl: require('../../assets/images/consult-menu/icon-default-dept.png'),
      menuShow: true,
      deptRecos: [],
      doctors: [],
      doctorInfo: {},
      pickerDataList: [],
      pickerFlag: false,
      content: '',
      hosp: '',
      dept: '',
      phospId: '',
      deptId: '',
      allLoaded: false,
      schedulDayList: [],
      pageNo: 1,
      rows: 15,
      timer: null,
      isConsult: '0',
      isFocus: false,
      loading: false,
      channelSelectedType: '',
      channelType: {
        // 在线咨询
        '0': {
          'img': '01',
          'video': '02'
        },
        // 在线复诊
        '1': {
          'img': '03',
          'video': '04'
        }
      },
      costMap: {
        '01': 'costsImage', // 图文咨询
        '02': 'costsVideo', // 视频咨询
        '03': 'costsImage', // 图文复诊
        '04': 'costsVideo'// 视频复诊
      },
      isFirstLoad: true,
      version: api.version,
      staffType: '5' // 心理医生
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'platId',
      'userInfo',
      'searchKey',
      'initHosp'
    ]),
    hospId () {
      return this.$route.query || ''
    }
  },
  created () {
    // 初始化没有心理医生权限时
    if (this.initHosp.enableMind !== true) {
      this.$router.push({ path: '/counselor' })
    }
    this.isMini = this.$store.getters.platform === 'mp' ? true : false
    this.initRecommendDepts()
    this.search()
  },
  mounted () {
  },
  methods: {
    getDefaultDeptUrl () {
      return `this.src='${this.defaultDeptUrl}'`
    },
    getDefaultAvatarUrl (gender) {
      if (gender === '1') {
        return `this.src='${this.defaultMaleAvatarUrl}'`
      } else {
        return `this.src='${this.defaultFemaleAvatarUrl}'`
      }
    },
    initRecommendDepts () {
      this.$http.getRecommendDepts('医生数据加载中，数据较多，请耐心等待').then(res => {
        this.deptRecos = res
      })
    },
    focus (data) {
      this.allLoaded = false
      this.result = []
      this.pageNo = 1
      this.content = data
      this.isFocus = true
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.clearSearch()
      }, 1000)
    },
    clear (data) {
      this.content = data
      this.clearSearch()
    },
    getList (isLoading, clearable) {
      this.loading = true
      this.$http.getDoctorsList(
        {
          phospId: this.searchKey.hosp.phospId || '',
          deptId: this.searchKey.dept.phospDeptId || '',
          content: this.content,
          staffType: this.staffType
        },
        {
          pageNo: this.pageNo,
          rows: this.rows
        },
        isLoading
      ).then(res => {
        if (res && res.length > 0) {
          this.doctors = clearable ? res : [...this.doctors, ...res]
          this.menuShow = true
          this.pageNo++
        } else {
          if (clearable) {
            this.menuShow = true
            this.doctors = []
          }
        }
        if (res.length < this.rows) {
          // if all data are loaded
          this.allLoaded = true
        }
        if (this.isFirstLoad) {
          this.isFirstLoad = false
          // 滚动1像素
          setTimeout(function () {
            window.scrollTo(0, 1)
          }, 300)
        }
        this.loading = false
      })
    },
    async search () {
      this.allLoaded = false
      this.doctors = []
      this.pageNo = 1
      // 单家医院
      if (this.initHosp.mode === '1') {
        let searchKey = this.$store.getters.searchKey
        searchKey.hosp = {
          phospId: this.initHosp.hospId
        }
        this.$store.commit('setSearchKey', searchKey)
      }
      this.getList()
    },
    clearSearch (val) {
      if (val) {
        this.content = val
      }
      this.allLoaded = false
      this.pageNo = 1
      this.getList(false, true)
    },
    searchDept (dept) {
      this.$router.push({
        name: 'result',
        query: {
          deptId: dept.deptId,
          deptName: dept.deptName
        }
      })
    },
    check (doctor) {
      this.$router.push({
        name: 'doctorInfo',
        query: {
          staffId: doctor.staffId,
          deptId: doctor.deptId,
          isConsult: '0'
        }
      })
    },
    filter (type, selectType) {
      if (type === 'hosp') {
        this.$router.push('/hospFilter')
      } else if (type === 'dept') {
        if (this.initHosp.mode === 2 && !this.searchKey.hosp.phospId) { // 没有选择医院，提示选择医院
          this.$toast('请先选择医院！')
        } else {
          this.$router.push({
            name: 'deptFilter',
            query: {
              selectType: selectType,
              phospId: this.searchKey.hosp.phospId || ''
            }
          })
        }
      }
    },
    loadMore () {
      if (this.allLoaded) {
        return
      }
      this.getList()
    },
    unlineMessageBox () {
      this.$messagebox({
        title: '温馨提示',
        message: '该医生有事已离线，您现在发起咨询，医生可能无法及时响应，是否确定发起咨询？',
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '确定'
      }).then(action => {
        if (action === 'confirm') {
          this.handleConsultion()
        }
      })
    },
    handleConsult (doc, type) {
      if (!this.$store.getters.token) {
        this.goUserReg()
        return false
      }
      doc.consultType = this.channelType[this.isConsult][type]
      this.doctorInfo = doc
      const channelTypeMap = {
        'img': 'statusImage',
        'video': 'statusVideo'
      }
      if ((this.isMini || type === 'img') && this.doctorInfo[channelTypeMap[type]] === '1') {
        // 医生离线无法视频咨询
        // if (this.doctorInfo.onlineStatus === '1'){
        // 视频咨询先查询有无排班信息
        if (type === 'video') {
          this.createForm()
        }
        // 医生在线、离线都可以发起图文咨询
        if (type === 'img') {
          this.createForm()
        }
        // } else {
        //   this.$toast('该医生已离线，暂时无法提供咨询服务')
        //   this.unlineMessageBox()
        // }
      } else {
        this.$toast('暂未开通该类型咨询渠道')
      }
    },
    // 关闭PickerComponent
    closePicker () {
      this.pickerFlag = false
    },
    createForm () {
      this.pickerFlag = false
      this.$http.checkStatus({
        consultType: this.doctorInfo.consultType,
        doctorId: this.doctorInfo.staffId,
        source: '2',
        resDate: this.doctorInfo.resTime
      }).then(res => {
        // 0-成功、1-您已加入同个类别候诊队列、2已加入不同类别候诊队列、其他错误码-失败
        // 0-加入队列成功，即不存在订单，直接跳转病情描述
        if (res.status === '0') {
          this.handleConsultion()
        // 1-已加入同个类别候诊队列，直接判断支付状态后跳转
        } else if (res.status === '1') {
          res.record.id && this.handleConsultInfo(res.record.id)
        // 2-已加入不同类别候诊队列
        } else if (res.status === '2') {
          this.$toast(res.msg)
        // 4-医生离线询问是否咨询
        } else if (res.status === '4') {
          this.unlineMessageBox()
        // 其他状态码-错误
        } else {
          this.$toast(res.msg)
        }
      })
    },
    handleConsultInfo (orderNo) {
      $services.getConsultInfoByOrderNo({
        orderNo: orderNo,
        userType: '01'
      }).then(res => {
        this.orderStatus = res.record.status
        // 未支付跳转订单详情
        if (this.orderStatus === '00') {
          this.$router.push({
            name: 'recordInfo',
            query: {
              orderNo: orderNo
            }
          })
          // 其他情况跳转IM
        } else {
          // 判断当前环境
          if (this.isMini === true && api.version !== 'fever') {
            wx.miniProgram.navigateTo({
              url: '/pages/imChat/main?userType=01&orderNo=' + orderNo + '&sessionId=' + this.$store.getters.token
            })
          } else {
            this.$router.push({
              path: '/imChat',
              query: {
                userType: '01',
                orderNo: orderNo
                // 如果是同一个服务下,sessionId可以不传
                // sessionId: this.$store.getters.token
              }
            })
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 视频咨询需要查询排班信息
    handleConsultion () {
      if (this.doctorInfo.consultType === '02') {
        this.$http.getSchedulList({
          consultType: '02',
          deptId: this.doctorInfo.deptId,
          doctorId: this.doctorInfo.staffId,
          hospId: this.doctorInfo.phospId
        }).then(res => {
          if (res.length > 0) {
            this.pickerDataList = res
            this.pickerFlag = true
          } else {
            this.enterConsultion()
          }
        })
      } else {
        this.enterConsultion()
      }
    },
    // 进入咨询页面
    enterConsultion () {
      let doc = this.doctorInfo
      this.$router.push({
        name: 'counsulation',
        query: {
          deptId: doc.deptId,
          deptName: doc.deptName,
          doctorId: doc.staffId,
          doctorName: doc.name,
          doctorProfessional: doc.postName,
          hospId: doc.phospId,
          hospName: doc.phospName,
          money: doc[this.costMap[doc.consultType]],
          consultType: doc.consultType,
          resTime: doc.resTime,
          numberId: doc.numberId,
          lockType: '02'
        }
      })
    },
    // 保留小数点两位
    financial (x) {
      return Number.parseFloat(x).toFixed(2)
    },
    // 跳转到登录页
    goUserReg () {
      this.$router.push({
        path: '/userReg',
        query: {
          platId: this.$route.query.platId
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/psychologist.vue